export default __webpack_public_path__ + "static/media/MobilePos-100k.46f7fba0.png";